import { baseSchema } from '../base'
import { Update, generate } from '../generate'
import * as z from 'zod'

export const blockRelationshipSchema = baseSchema.extend({
  branchId: z.string(),
  validFrom: z.string(),
  validTo: z.string().optional(),
  parentId: z.string(), // by sourceBlockId
  order: z.string(), // string-based fractional-index
  blockId: z.string(), // by regular id
  sourceBlockId: z.string(),
  structural: z.boolean(),
  isCommitted: z.boolean(),
  discardedAt: z.string().optional(),
  placeholderSince: z.string().optional(),
  isInlineSuggestion: z.literal(true).nullish(),
  playgroundId: z.string().optional(),
})

export type BlockRelationship = z.infer<typeof blockRelationshipSchema>
export type BlockRelationshipUpdate = Update<BlockRelationship>

export const blockRelationshipBaseOps = generate(
  'br',
  blockRelationshipSchema.parse
)

export * from './compound-indexes'
export * from './order'
export * from './hash'
export * from './structural'
